<template>
    <div>
        <el-upload
            v-if="temAcesso('Arquivo','Importar')"
            class="upload"
            drag
            name="file"
            :on-success="handleSuccess"
            :action="$urls.UPLOAD_FILE"
            :file-list="fileList"
            :on-error="handleError"
            :http-request="handleRequest"
            multiple
            accept=".csv, .xlsx"
            ref="upload"
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Arraste seus arquivos aqui ou <em>clique para enviar</em></div>
            <div
            class="el-upload__tip"
            slot="tip"
            >Permitidos apenas arquivos <b>.csv e .xlsx</b></div>
        </el-upload>
        <el-upload
            v-else
            class="upload no-drop"
            disabled
            drag
            name="file"
            :on-success="handleSuccess"
            :action="$urls.UPLOAD_FILE"
            :file-list="fileList"
            :on-error="handleError"
            :http-request="handleRequest"
            multiple
            accept=".csv, .xlsx"
            ref="upload"
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Sem permissão para adicionar arquivos</div>
            <div
            class="el-upload__tip"
            slot="tip"
            >Permitidos apenas arquivos <b>.csv e .xlsx</b></div>
        </el-upload>
    </div>
</template>

<script>

export default {
    name: "UploadItem",
    data() {
        return {
            fileList: [],
            listaArquivosEnviados: [],
            nomeDoArquivoTemp: "",
        }
    },
    props: {
        tipoArquivo: {
            type: Number,
            required: true
        }
    },
    mounted(){
        const vmo = this


        this.axios.interceptors.request.use((config) => {
                 vmo.handleLoadingFile(true, vmo.listaArquivosEnviados)

                return config;
            });
    },
    methods: {
        handleSuccess(response, file, fileList){
            this.handleLoadingFile(false, file.name)

            this.$notify({
                type: "success",
                title: 'Upload de arquivos',
                message: `${file.name} enviado com sucesso`
            });

        },
        handleLoadingFile(loading, arquivo){
            const listaUploads = this.$refs.upload ? this.$refs.upload.$el.querySelectorAll('.el-upload-list li') : [];
            const vmo = this;
                 
            if(listaUploads.length > 0){
                    listaUploads.forEach(function(item){
                      const isCSV = /\.csv$/i.test(item.innerText.trim());
                      const nomeArquivo = isCSV ? item.innerText.trim() : "arquivoDefault";
                      const i = item.querySelector('label i');

                      vmo.statusArquivoEnviado(loading, arquivo, nomeArquivo, i);
                 })
            }

        },
        statusArquivoEnviado(loading, arquivoSendoProcessado, nomeArquivo, icone){
            const arquivoSendoEnviado = () => {
                icone.classList.add(`el-icon-loading`)
                icone.classList.remove("el-icon-circle-check")
            }

            const arquivoFoiEnviado = () =>{
                 icone.classList.add('el-icon-circle-check')
                icone.classList.remove('el-icon-loading')
            }

            if(loading){
                if(arquivoSendoProcessado.filter(item => item === nomeArquivo).length > 0){
                    arquivoSendoEnviado()
                }
            }else if(arquivoSendoProcessado === nomeArquivo){
                arquivoFoiEnviado()

                //remove os arquivo que já foram enviado
                this.listaArquivosEnviados = this.listaArquivosEnviados.filter(item => item != nomeArquivo)
            }
        },
        handleError(err, file, fileList){
            this.$notify({
                type: "error",
                title: 'Upload de arquivos',
                message: `Ocorreu um erro ao processar seu arquivo ${file.name}`
            });
        },
        async handleRequest(data){
            const formData = new FormData();
            
            const { file }  = data
                        
            formData.append('file', file);
            formData.append('tipoArquivo', this.tipoArquivo)
            
            this.listaArquivosEnviados.push(file.name) 

            await this.axios.post(this.$urls.UPLOAD_FILE, formData)
        
        }
    },
}
</script>
<style lang="scss">
.el-upload{
    width: 100%;

    .el-upload-dragger{
        width: 100% !important;
    }
}

.el-upload-list label.el-upload-list__item-status-label{
    display: block !important;
}
.no-drop .el-upload-dragger { cursor:no-drop !important;}
</style>
